import { render } from "./SidebarFaturamento.vue?vue&type=template&id=70487e8e&scoped=true"
import script from "./SidebarFaturamento.vue?vue&type=script&lang=js"
export * from "./SidebarFaturamento.vue?vue&type=script&lang=js"

import "./SidebarFaturamento.vue?vue&type=style&index=0&id=70487e8e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70487e8e"]])

export default __exports__